export default __webpack_public_path__ + "static/media/team-du.373011c4.jpg";